<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
      <section class="section1 mt-2 pb-4">
          <div class="container row no-gutters mx-auto ">
                <!-- plan selection cards -->
                    <div class="col-md-12 col-lg-12 pb-5">
                        <div class="row no-gutters d-none d-md-block">
                            <br />
                        </div>
                        <div class="no-gutters mt-lg-5 ">
                            <div class="col-lg-12 mt-5 mt-lg-3"> 
                                <div class="row no-gutters">
                                    <br />
                                </div>
                                <div class="d-flex mt-3 mt-lg-0 ml-3 mr-3 pt-lg-3">
                                    <span class="fontsize20 proximanova-semibold black mx-auto">Subscription plans</span>
                                </div>
                                <div class="ml-3 mr-3 d-flex justify-content-between">
                                    <span class="fontsize12 proximanova black60 mt-2 mx-auto">Choose Annual plan to save 30%</span>
                                </div>
                                <!-- <div class="d-flex p-1 backgroundcolor9 col col-md-6 mt-4 borderadius12 col-lg-3 mx-auto"> -->
                                <div class="d-flex p-1 backgroundcolor9 mt-4 borderadius12 col-3 mx-auto">
                                    <div class="p-1 proximanova mt-0 col-12 text-center black fontsize14 pointer" 
                                        :class="{'backgroundcolor3 borderadius12 white':type == 'Professional'}" 
                                        @click="chooseType('Professional')"
                                    >Professional</div>
                                    <!-- <div class="p-1 proximanova mt-0 col-6 text-center black fontsize14 pointer" 
                                        :class="{'backgroundcolor3 borderadius12 white':type == 'Business'}"
                                        @click="chooseType('Business')"
                                    >Business</div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                            <div class="d-flex justify-content-between mr-3">
                                <div class="d-flex mx-auto">
                                    <span class="fontsm proximanova fontbold mt-2 pt-1 mr-lg-3 mr-1">Billing Country</span>
                                    <!-- <select name="billingCountry" id="billingCountry" disabled class="proximanova borderradius20" v-model="billingCountry" @change="setCurrencyType">
                                        <option value="USA">USA</option>
                                        <option value="India">India</option>
                                    </select> -->
                                    <span id="billingCountry1" disabled class="proximanova borderradius20 fontsize14 my-auto">United States of America (USA)</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-11 mt-3">
                            <div class="d-flex justify-content-between mr-3">
                                
                                <!-- <div>
                                    <img src="../assets/Info.svg" alt="info">
                                    <button class="freetrailbtn ml-2" v-if="this.remainingDaysLeft < 1 && this.freeTrailAccess !== 'Y'" @click="FreetrailAccess">Free trail</button>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-11 col-md-12 viewercards row no-gutters mb-4 mt-4 mx-auto justify-content-between" >
                            <div class="col-lg-4 col-md-6">
                                <div class="card p-3 ml-md-3 mr-lg-3 mb-2 pointer">
                                    <!-- <div class="tickmark" v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually'">&#10003;</div> -->
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Free Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="amountcolor proximanova" v-if="currencyType === 'USD'">$0</span>
                                        <span class="amountcolor proximanova" v-if="currencyType === 'INR'">₹0</span>
                                        <span class="fontsize12 proximanova black60 p-1">Free forever</span>
                                        <!-- <span class="fontsize14 black pb-1 proximanova" >After free trail - $70 / Annual</span> -->
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold borderradius20 mouseoverbtn2 fontsize16 black80" @click="NavToSignup('free')">Get Started</button>
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <!-- <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">30 days free trail</li> -->
                                            <!-- <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Access to connect premium accounts</li> -->
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Find who viewed my profile upto 3 profiles</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Upto 3 profiles - Find who viewed my video profile</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Upto 3 profiles - Find who viewed your video's</li>
                                            <!-- <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Connect directly with recruiters</li> -->
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="card p-3 ml-md-3 ml-lg-3 mr-lg-3 mr-md-0 mr-lg-0 mb-2 pointer">
                                    <!-- <div class="tickmark" v-if="currentPlanDetails && currentPlanDetails.planType === 'Monthly'">&#10003;</div> -->
                                    <div class="">
                                        <span class="float-right suggestedpillbtn fontsize12 proximanova-bold greendark proximanova">Popular</span>
                                    </div>
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Monthly Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="amountcolor proximanova" v-if="currencyType === 'USD'">${{monthlyPlanAmount}}</span>
                                        <span class="amountcolor proximanova" v-if="currencyType === 'INR'">₹{{monthlyPlanAmount}}</span>
                                        <span class="fontsize12 proximanova black60 p-1">30 days free trail</span>
                                        <!-- <span class="fontsize14 black pb-1 proximanova">After free trail - ₹30 / Month</span> -->
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold borderradius20 mouseoverbtn2 fontsize16 black80" @click="NavToSignup('Monthly')">Get Started</button>
                                           
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit"> 30 days free trail</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Access to connect premium accounts</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my profile</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my video profile</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed your video's</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Connect directly with recruiters</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="card p-3 ml-md-3 mr-lg-3 mb-2 pointer">
                                    <!-- <div class="tickmark" v-if="currentPlanDetails && currentPlanDetails.planType === 'Annually'">&#10003;</div> -->
                                    <div class="">
                                        <span class="float-right suggestedpillbtn fontsize12 proximanova-bold greendark proximanova">Popular</span>
                                    </div>
                                    <div class="mt-2 text-center">
                                        <span class="fontsize24 proximanova black">Annual Plan</span>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column text-center">
                                        <span class="amountcolor proximanova" v-if="currencyType === 'USD'">${{annualPlanAmount}}</span>
                                        <span class="amountcolor proximanova" v-if="currencyType === 'INR'">₹{{annualPlanAmount}}</span>
                                        <span class="fontsize12 proximanova black60 p-1">30 days free trail</span>
                                        <!-- <span class="fontsize14 black pb-1 proximanova" >After free trail - $70 / Annual</span> -->
                                    </div>
                                    <div class="mb-2 p-3 text-center">
                                        <div class="d-flex flex-column btnsection">
                                            <button type="button" 
                                            class="btn followbtn proximanova-bold borderradius20 mouseoverbtn2 fontsize16 black80" @click="NavToSignup('Annually')">Get Started</button>
                                        </div>
                                    </div>
                                    <div class="hotizonline p-2 mb-2"></div>
                                    <div class="d-flex flex-column">
                                        <span class="font16black ml-2 mb-2 proximanova">Benefits</span>
                                        <ul class="fontsize12 black benifits proximanova pl-0 ml-2">
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">30 days free trail</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Access to connect premium accounts</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my profile</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed my video profile</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Unlimited - Find who viewed your video's</li>
                                            <li> <img src="../../assets/SelectPlanBenefits.svg" class="mr-2" alt="benefit">Connect directly with recruiters</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </section>
        
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../LandingFooter.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
        type : 'Professional',
        currencyType : 'USD',
        billingCountry : 'USA',
        tax : 8.25,
        monthlyPlanAmount : 10,
        annualPlanAmount : 80,
    };
  },
  methods: {
    chooseType(type) {
        this.type = type
    },
    setCurrencyType() {
        if(this.billingCountry === 'USA'){
            this.currencyType = 'USD'
            this.tax = 8.25
            this.monthlyPlanAmount = this.monthlyPlanAmount / 75;
            this.annualPlanAmount = this.annualPlanAmount / 75;
            this.selectedPlanAmount = this.selectedPlanAmount / 75;
        }else{
            this.currencyType = 'INR'
            this.tax = 18
            this.monthlyPlanAmount = this.monthlyPlanAmount * 75;
            this.annualPlanAmount = this.annualPlanAmount * 75;
            this.selectedPlanAmount = this.selectedPlanAmount * 75
        }
    },
    NavToSignup(planType){
        if(planType !== 'free'){
            localStorage.setItem("selectedPlan", planType)
            localStorage.setItem("selectedPlanCard", true)
            localStorage.setItem("billingCountry", this.billingCountry)
            router.push({
                name : 'signup'
            })
        }else{
            router.push({
                name : 'signup'
            })
        }
    },
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
};
</script>
<style scoped>
section {
 margin: 0 0 0rem 0rem  !important ;
}
#billingCountry{
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 10px 5px 10px;
    height: 38px;
    background: none;
    color: black;
    border-radius: 10px;
}
#billingCountry1{
    border: 1px solid rgba(0, 0, 0, 0.1);
    line-height: 38px;
    padding: 0 10px;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.engage-margin{
  margin-top: -20%;
}
.padding-track{
  margin-top: -15%;
}
.main-background{
  transform: translate(-1%, -67%);
  width: 100%;
}
h2{
  font-weight: 300;
}
.imgfile{
  position: relative;
  transform: translate(-50%, -12%);
  z-index: 100;
}
.section1 {
  background-color:#fdfdfd;
}
.section2 {
  background-color:white;
}
.video_resume{
  margin-top: -65%
}    
.section4{
  background-color:rgba(240, 241, 243,0.3);

}
.tickmark{
    width: 25px;
    height: 25px;
    background: #007AFF;
    position: absolute;
    right: 0;
    top: 0;
    margin-right: -2px;
    border-radius: 8px;
    text-align: center;
    color: white;
    padding-bottom: 2px;
}
ul {
   list-style: none;
   line-height: 24px;
}
.hotizonline {
    border-bottom: 1px solid #DDE0E6;
}
.benifits{
    margin-left: -1em;
}
.benifits li{
    padding: .25em;
}
.card {
  border: 1px solid #e4e5e7;
  border-radius: 10px;
  background-color: #ffffff;
  transition: transform .3s;
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
    width: 150px;
    margin: auto;
}
@media screen and (min-width : 768px) {
    .card:hover {
        box-shadow: 0 10px 15px rgba(33,33,33,.2);
        border: 1px solid #007AFF;
        -ms-transform: scale(1.05); /* IE 9 */
        -webkit-transform: scale(1.05); /* Safari 3-8 */
        transform: scale(1.05);
    }
    .card:hover .followbtn{
        background: black !important;
        color: white !important;
    }
}
</style>
